module.exports = __webpack_public_path__ + "img/damen_und_herren_duefte_kachel_DAMENCLASSICS.ba17364c.png";